/* eslint-disable */
export default {
  recentActivities: 'Atividades recentes',
  text: 'Texto',
  fax: 'Fax',
  voicemail: 'Caixa postal',
  call: 'Chamada',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
